import { Card as MuiCard, CardProps } from "@mui/material";

const styles = {
    root: {
        height: "100%",
        py: 3,
        px: 3,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "greyscale.100",
        borderRadius: "8px",
        boxShadow: "0px 1px 2px rgba(15, 15, 66, 0.06)"
    }
};

interface McpCardProps extends CardProps {
    children: React.ReactNode;
    useFullWidth?: boolean;
}

export const McpCard: React.FC<McpCardProps> = ({ children, useFullWidth, ...props }) => {
    return (
        <MuiCard sx={styles.root} {...props}>
            {children}
        </MuiCard>
    );
};

export default McpCard;
